import { FC, JSX } from "react";
import { Spinner } from "@radix-ui/themes";
import JobSingleUI from "./job.single.ui";
import { useSingleJob } from "../../hooks/useSingleJob";

interface JobSingleFetcherProps {
  slug: string;
}

const JobSingleFetcher: FC<JobSingleFetcherProps> = ({
  slug,
}): JSX.Element | null => {
  const { data, loading, error } = useSingleJob(slug);

  if (loading) return <Spinner />;

  if (error) throw error.message;

  if (data) {
    return <JobSingleUI {...data} />;
  }
  return null;
};

export default JobSingleFetcher;
